/* eslint-disable max-statements */
import { PageLoadEvent } from '../../../types/events';
import { Ecommerce } from '../../../types/datalayer/pageview';
import {
  searchImpressions,
  formatFilters,
  getAggregation,
  hasAggregationValue,
  hasSelectedAggregation,
} from './helpers';
import { PageViewEvent } from '../../../types/datalayer/pageview';
import { Dimensions } from '../../../types/dimensions';

export default (pageload: PageLoadEvent): PageViewEvent => {
  const search = pageload.detail?.search || {};
  const { results, limit, offset, sortBy } = search;
  const selectedAggregations = search.selectedAggregations || [];
  const impressionId = search.ads?.impressionId || undefined;
  const productList = search.productList || '';
  const productIds = search.productIds || [];
  const content = search.content || {};
  const suggestions = content.suggestions || [];
  const marketAggregation = getAggregation(search?.aggregations, 'origin');
  const isMarketSearch = hasAggregationValue(marketAggregation?.options, 'mercado');
  const isMarketSelected = hasSelectedAggregation(search?.selectedAggregations, 'mercado');
  const dimensions = {} as Dimensions;

  const ecommerce = { impressions: searchImpressions(productList, isMarketSelected) } as Ecommerce;
  const sortByFlagConfig: Record<string, string> = {
    higherPriceRelevance: 'flag-maiores-precos',
    lowerPriceRelevance: 'flag-menores-precos',
  };

  if (isMarketSearch) {
    dimensions.dimension116 = 'Banner_busca_amercado';
  }

  return {
    searchTerm: content.term?.toLocaleLowerCase(),
    searchResults: results?.toString(),
    searchProducts: productIds.join(),
    searchActualTerm: suggestions[0]?.term,
    searchFilters: formatFilters(selectedAggregations),
    searchLimit: limit,
    searchOffset: offset == null ? 1 : offset,
    searchSortBy: sortBy,
    searchImpressions: productIds.length > 0 ? 1 : 0,
    didYouMeanUsed: suggestions[0]?.used ? 1 : 0,
    didYouMeanNotUsed: content.used ? 1 : 0,
    didYouMean: suggestions.length > 0 ? 1 : 0,
    ecommerce,
    sortByFlag: sortByFlagConfig[sortBy],
    impressionId,
    ...dimensions,
  } as PageViewEvent;
};
